import { render } from "./CsvValidationsResult.vue?vue&type=template&id=fdd6c904&scoped=true"
import script from "./CsvValidationsResult.vue?vue&type=script&lang=js"
export * from "./CsvValidationsResult.vue?vue&type=script&lang=js"

import "./CsvValidationsResult.vue?vue&type=style&index=0&id=fdd6c904&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd6c904"]])

export default __exports__